import {merge} from 'lodash';
import AssessmentResult from '../../../values/AssessmentResult';
import Assessment from '../assessment';
import {KEYWORD_POINTS, RELATED_KEYWORDS_ID} from '@axyseo/const/analysis';

/**
 * Represents the assessment that checks whether there are enough transition words in the text.
 */
export default class RelatedKeywordsAssessment extends Assessment {
  /**
   * Sets the identifier and the config.
   *
   * @param {object} config The configuration to use.
   *
   * @returns {void}
   */
  constructor(config = {}) {
    super();

    const defaultConfig = {
      id: RELATED_KEYWORDS_ID,
      fixPosition: 'description',
      ctaType: 'fix',
      docUrl:
        'https://docs.avada.io/seo-suite-help-center/seo-audit/on-page-seo/checklist#related-keywords',
      priority: 'high',
      title: 'Related keywords',
      content: {
        good: 'Related keywords set',
        bad:
          'Related keywords field is empty. Add a few relevant phrases.',
        improve: ''
      }
    };

    this.identifier = RELATED_KEYWORDS_ID;
    this._config = merge(defaultConfig, config);
  }

  /**
   *
   * @param relatedKeywords
   * @returns {{score: number, status: string, words}}
   */
  calculateResult(relatedKeywords) {
    const isHasRelatedKeywords = relatedKeywords && relatedKeywords?.length > 0;
    const status = isHasRelatedKeywords ? 'good' : 'bad';
    const score = this.getScore(KEYWORD_POINTS, status);

    return {
      score,
      status
    };
  }

  /**
   *
   * @param paper
   * @param researcher
   * @returns {AssessmentResult}
   */
  getResult({paper, researcher}) {
    const relatedKeywords = paper.getRelatedKeywords()
    const result = this.calculateResult( relatedKeywords);
    const assessmentResult = new AssessmentResult({config: this._config});

    assessmentResult.setScore(result.score);
    assessmentResult.setStatus(result.status);

    return assessmentResult;
  }

  /**
   * Checks if the transition words assessment is applicable to the paper. Language-specific length requirements and methods of counting text length
   * may apply (e.g. for Japanese, the text should be counted in characters instead of words, which also makes the minimum required length higher).
   *
   * @param {Paper}       paper       The paper to check.
   * @param {Researcher}  researcher  The researcher object.
   *
   * @returns {boolean} Returns true if the language is available, the paper is not empty and the text is longer than the minimum required length.
   */
  isApplicable(paper, researcher) {
    return true;
  }
}
